import * as React from "react";
import {ReactElement, useEffect} from "react";
import {useStore, useStoreValue} from "react-context-hook";
import {getText} from "../../services/configuration.service";
import Icon from "../Icon";
import {getCapacityLabel} from "../../services/label.service";
import {handleClickCustomSelect, handleClosePanel} from "../../../../../../elements/customSelect/customSelect";
import {getUrlVar} from "orxapi.tools.url";
import {urlParametersConfig} from "../../../config/form";

const SelectCapacity = (): ReactElement => {
    const bookingEngineData = useStoreValue("bookingEngineData");
    const selectedDepartureCity = useStoreValue("selectedDepartureCity");
    const [selectedCapacity, setSelectedCapacity] = useStore("selectedCapacity");

    const adultNumber = getUrlVar()[urlParametersConfig.adults];
    const childrenNumber = getUrlVar()[urlParametersConfig.children];

    const availabilities = (bookingEngineData || {}).availabilities;
    const basePriceAvailability = ((bookingEngineData || {}).product || {}).basePriceAvailability;
    const capacities: string[] = availabilities && selectedDepartureCity && availabilities[selectedDepartureCity.code] && Object.keys(availabilities[selectedDepartureCity.code]);
    const selectLabel = (selectedCapacity && getCapacityLabel(selectedCapacity.code)) || getText("booking.loading.label");
    const defaultDepartureCityCode = basePriceAvailability?.departureCity?.code;

    useEffect(() => {

        if (!selectedCapacity) { // first arrival in page
            if (basePriceAvailability) {
                // Select capacity of the base price availability of the product
                let capacityCode = basePriceAvailability.minPax + "-" + basePriceAvailability.maxPax;
                if (adultNumber && childrenNumber) {
                    const minMax = basePriceAvailability.minPax + "-" + (Number(adultNumber) + Number(childrenNumber));
                    //exclude the minmax not exist
                    if (availabilities[defaultDepartureCityCode][minMax]) {
                        capacityCode = minMax;
                    }
                }
                setSelectedCapacity({
                    code: capacityCode,
                    value: availabilities[defaultDepartureCityCode][capacityCode]
                });
            }
        }

    }, [bookingEngineData]);

    const selectCapacity = (capacityCode: string) => {
        if (selectedCapacity.code !== capacityCode) {
            setSelectedCapacity({code: capacityCode,
                value: availabilities[defaultDepartureCityCode][capacityCode]});
            handleClosePanel();
        }
    };

    return (
        <div className={"booking-item js-switch-active"}>
            <div className="label">{getText("booking.select.capacity.label")}</div>

            <div className={"elem-custom-select"}>
                <div className="custom-select-mask">
                    <div className="custom-select-input" onClick={(evt) => handleClickCustomSelect(evt)}>
                        <div className="custom-select-input-txt">
                            <Icon icon={"l"} addClass={"location-icon"}/>
                            <div className="label-style">{selectLabel}</div>
                        </div>
                        <div className="custom-select-input-button">{getText("booking.select.change")}</div>
                    </div>
                </div>
                <div className="custom-select-panel d-none">

                    <div className="title-block">
                        <div className="label-block">
                            <div className="label">{getText("booking.select.capacities.available")}</div>
                            <div className="legend">{"Sélectionnez"}</div>
                        </div>
                        <div className="icon-wrap btn-close-custom-select" onClick={handleClosePanel}>
                            <Icon icon={"x"}/>
                        </div>
                    </div>
                    <div className="custom-select-panel-content">
                        {!capacities &&
                            <div
                                className="panel-content-item placeholder-style">{getText("booking.loading.label")}</div>
                        }
                        {capacities && capacities.map((capacity: string) =>
                            <div
                                key={capacity}
                                onClick={() => selectCapacity(capacity)}
                                className={`panel-content-item ${capacity === selectedCapacity.code ? "selected" : ""}`}
                            >
                                {getCapacityLabel(capacity)}
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SelectCapacity;
